import { colors } from '../../../theme/colors';
import { typography } from '../../../theme/typography';

export const getDefaultChartOptions = (type) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            family: typography.fontFamily,
            size: 12,
          },
          color: colors.brandDarkBlue,
          usePointStyle: true,
          padding: 20,
        },
      },
      tooltip: {
        backgroundColor: 'rgba(0, 107, 156, 0.9)',
        titleFont: {
          family: typography.fontFamily,
          size: 14,
          weight: 'bold',
        },
        bodyFont: {
          family: typography.fontFamily,
          size: 13,
        },
        padding: 12,
        cornerRadius: 8,
        displayColors: true,
      },
    },
    scales:
      type === 'bar' || type === 'line'
        ? {
            x: {
              grid: {
                display: false,
              },
              ticks: {
                font: {
                  family: typography.fontFamily,
                  size: 11,
                },
                color: colors.brandMediumGray,
              },
            },
            y: {
              grid: {
                color: colors.brandOffWhite,
                drawBorder: false,
              },
              ticks: {
                font: {
                  family: typography.fontFamily,
                  size: 11,
                },
                color: colors.brandMediumGray,
                padding: 10,
              },
            },
          }
        : {},
  };
};

export const getCombinedChartOptions = (type, options = {}) => {
  const defaultOpts = getDefaultChartOptions(type);
  const userPlugins = options.plugins || {};
  return {
    ...defaultOpts,
    ...options,
    plugins: {
      ...defaultOpts.plugins,
      ...userPlugins,
      legend: {
        ...defaultOpts.plugins.legend,
        ...(userPlugins.legend || {}),
      },
      tooltip: {
        ...defaultOpts.plugins.tooltip,
        ...(userPlugins.tooltip || {}),
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Chart/utils/chartHelpers.js